declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}

export const isInWebView = "ReactNativeWebView" in window;

export const isInPlayer = navigator && navigator.userAgent && navigator.userAgent.includes("Castit");

// we're setting the display mode to fullscreen in the manifest.json
// therefore we can use this to check if we're in a PWA
export const isPWA = !!window?.matchMedia('(display-mode: fullscreen)')?.matches;

/**
 * Disable virtual keyboard if we are inside a webview
 */
export const isVirtualKeyboardEnabled = !isInWebView;